export default __webpack_public_path__ + "static/media/p3.025b4a29.jpg";